export default "__VITE_ASSET__CVunXkTQ__"